import React from "react";
const isOperator = (ch) => {
  return isNaN(ch) && ch !== "=" && ch !== ".";
};

export const Button = ({ children, onClick }, props) => {
  return (
    <div
      className={`btn ${isOperator(children) ? "operator" : null}`}
      onClick={() => onClick(children)}
    >
      {children}
    </div>
  );
};
